module.exports = __webpack_public_path__ + "static/media/Girl.a993b27a.png";